import randomId from 'random-id';
import { FileUrlFields } from 'drapcode-constant';
import {
  fieldTraitProgressBarOptions,
  fieldTraitTextContentOptions,
  filterFieldTraitOptions,
} from '../../dataGroup/traitsApi';
import { getCollectionFields } from '../../pluginComponentApi';

export const AddToCartButton = (bm, category, label, type, config) => {
  const addToCartBtnId = 'snipcart-add-item' + randomId(8, '');
  bm.add(type, {
    label: `<i class="webconnect-bag-check"></i><div>${label}</div>`,
    category: category,
    content: `
      <button id="${addToCartBtnId}" class="snipcart-add-item btn btn-primary mx-2"
        data-gjs-type="${type}"
        data-gjs-custom-name="${label}"
        data-item-id=""
        data-item-price="0.00"
        data-item-description=""
        data-item-image=""
        data-item-name="">Buy now</button>
    `,
    render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${label}?"></i>
        </a>
      </span>
    `,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('bootstrap_button');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections, snipcartApiKey } = config;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-bag-check"></i>',
          resizable: 1,
          droppable: true,
          projectId: projectId,
          snipcartApiKey: snipcartApiKey,
          'custom-name': label,
          collectionName: '',
          serverUrl: `${process.env.REACT_EXCHANGE_ENGINE}`,
        },
        async init() {
          const collectionName = this.get('collectionName');
          let options = [{ value: '', name: '- Select Collection -', disabled: true }];
          collections.forEach((item) => {
            options.push({ value: item.collectionName, name: item.collectionTitle });
          });
          this.addTrait([
            {
              type: 'select',
              label: 'Collection Name',
              name: 'collectionName',
              changeProp: 1,
              options: options,
            },
          ]);
          this.on('change:collectionName', this.handleCollectionChange);
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const collectionResponse = await getCollectionFields(collectionName, collections);
          this.setAttributes({
            selectedCollectionData: collectionResponse,
          });
          if (collectionResponse) {
            const finderOptions = [];
            collectionResponse.finders.forEach((finder) => {
              finderOptions.push({ value: finder.uuid, name: finder.name });
            });
            this.removeTrait('data-item-name');
            this.removeTrait('data-item-price');
            this.removeTrait('data-item-description');
            this.removeTrait('data-item-image');
            const numberFieldTraitsOptions = fieldTraitProgressBarOptions(collectionResponse);
            const fieldImageTraitsOptions = await filterFieldTraitOptions(
              collectionResponse,
              FileUrlFields,
            );
            const fieldTraitsOptions = await fieldTraitTextContentOptions(
              collectionResponse,
              collections,
            );
            this.addTrait({
              name: 'data-item-name',
              label: 'Name',
              title: `name`,
              options: fieldTraitsOptions,
              type: 'data-snipcart-trait',
            });
            this.addTrait({
              name: 'data-item-price',
              label: 'Price',
              title: `price`,
              options: numberFieldTraitsOptions,
              type: 'data-snipcart-trait',
            });
            this.addTrait({
              name: 'data-item-description',
              label: 'Description',
              options: fieldTraitsOptions,
              title: `description`,
              type: 'data-snipcart-trait',
            });
            this.addTrait({
              name: 'data-item-image',
              label: 'Image URL',
              options: fieldImageTraitsOptions,
              title: `image-url`,
              type: 'data-snipcart-trait',
            });
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:collectionName', this.updateScript);
      },
    }),
  });
};
